export const STARTED_FETCHING_GAMES_AVAILABLE = "STARTED_FETCHING_GAMES_AVAILABLE"
export const FINISHED_FETCHING_GAMES_AVAILABLE = "FINISHED_FETCHING_GAMES_AVAILABLE"